import styled from 'styled-components'
import { Alert, InlineMessage, InputLabel, SideNavItem, Text } from '@amzn/storm-ui'
import { GREY_10, SQUID_INK } from '@amzn/aapn-react-components'

export type SideNavProps = {
  hide?: boolean
}

export const PageContent = styled.div`
  display: flex;
`

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`

export const SideNavOuterWrapper = styled.div<SideNavProps>`
  background-color: ${GREY_10};
  flex: 0 0 ${({ hide }) => (hide ? '0' : '230px')};
  ${({ hide }) => hide && 'animation: gone .2s ease normal forwards;'}
  overflow-x: hidden;
  @keyframes gone {
    0% {
      flex: 0 0 230px;
      padding: ${({ theme }) => theme.spacing.large} ${({ theme }) => theme.spacing.medium};
    }
    100% {
      flex: 0 0 0px;
      padding: 0;
    }
  }
`

export const SideNavWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing.large} ${({ theme }) => theme.spacing.medium};
`

export const StyledSideNavItem = styled(SideNavItem)`
  border-radius: 3px;
  border-left: none;
  ${({ isActive }) => isActive && `background-color: ${SQUID_INK}1a`};
  padding: ${({ theme }) => theme.spacing.small};
  width: 100%;
  font-size: ${({ theme }) => theme.typography.size.small};
  color: ${({ theme, isActive }) => (isActive ? theme.color.black : theme.color.emperor)};
  font-weight: ${({ isActive }) => (isActive ? '700' : '400')};
  margin: 1px 0;
  :hover {
    background-color: ${SQUID_INK}0d;
    font-weight: ${({ isActive }) => (isActive ? '700' : '400')};
  }
`

export const EmptyResultsContainer = styled.div`
  height: 300px;
  border: 1px solid ${({ theme }) => theme.palette.mercury};
  border-top: none;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-top: 10em;
`

export const TableContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.mini};
  width: 100%;
`

export const TableActionContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.concrete};
  border: 1px solid ${({ theme }) => theme.palette.mercury};
  border-bottom: 0px;
  padding: ${({ theme }) => theme.spacing.mini} ${({ theme }) => theme.spacing.base};
  display: flex;
  gap: ${({ theme }) => theme.spacing.mini};
  align-items: baseline;
`

export const ConsoleTableContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.mini};
  width: 100%;
  td {
    border-inline-end: 0px;
  }
  th {
    border-inline-end: 0px;
  }
`

export const StyledCopyText = styled(Text)`
  max-width: 800px;
`

export const InviteButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: ${({ theme }) => theme.spacing.base};
`

export const PaginationNavContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: ${({ theme }) => theme.spacing.small} 0;
`

export type StyledAlertProps = {
  type: string
}

export const StyledAlertWithMargin = styled(Alert).attrs((props: StyledAlertProps) => ({
  type: props.type ?? 'error',
}))`
  margin-bottom: ${({ theme }) => theme.spacing.large};
`

export const ControlColumn = styled.div`
  flex: 0 0 auto;
  text-align: left;
`

export const StyledInputLabel = styled(InputLabel)`
  font-size: small;
  margin-bottom: ${({ theme }) => theme.spacing.mini};
`

export const Refinement = styled.div`
  padding: ${({ theme }) => theme.spacing.micro};
`

export const RefinementContainer = styled.div`
  display: flex;
`

export const StyledInlineMessage = styled(InlineMessage)`
  white-space: normal;
`
